export const PatientIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={19}
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.4}
      d="M14.795 15.835c-.341-.957-1.095-1.802-2.143-2.405-1.047-.603-2.331-.93-3.652-.93-1.32 0-2.605.327-3.652.93-1.048.603-1.802 1.448-2.143 2.405M9 9.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
    />
  </svg>
);
